import { supabase } from '../../shared/supabase/supabaseClient';
import { parseTreasuryPeriodSummary } from '../domain/parseTreasuryPeriodSummary';
import type { BranchTreasuryPeriodSummary } from '../domain/reportsTreasuryTypes';
import {
  invalidateReportsCache,
  reportsCacheKey,
  REPORTS_REMOTE_CACHE_MS,
  withReportsCache,
} from './reportsRemoteCache';
import { mapRpcError } from './reportsRemoteShared';

export async function fetchRemoteTreasuryPeriodSummary(
  branchId: string,
  fromIso: string,
  toIso: string,
  options?: { force?: boolean }
): Promise<BranchTreasuryPeriodSummary | null> {
  const cacheKey = reportsCacheKey(['reports_branch_treasury_period_summary', branchId, fromIso, toIso]);
  const fetchRemote = async (): Promise<BranchTreasuryPeriodSummary | null> => {
    const { data, error } = await supabase.schema('pos').rpc('reports_branch_treasury_period_summary', {
      p_branch_id: branchId,
      p_from: fromIso,
      p_to: toIso,
    });
    if (error) {
      console.warn('[reportsRemote] reports_branch_treasury_period_summary', mapRpcError(error));
      return null;
    }
    if (!data || typeof data !== 'object') return null;
    return parseTreasuryPeriodSummary(data as Record<string, unknown>);
  };

  if (options?.force) {
    return fetchRemote();
  }

  return withReportsCache(
    cacheKey,
    fetchRemote,
    REPORTS_REMOTE_CACHE_MS,
    { category: 'reports', name: 'reports_branch_treasury_period_summary' }
  );
}

export function invalidateRemoteTreasuryReportsCache(branchId: string): void {
  invalidateReportsCache(`reports_branch_treasury_period_summary|${branchId}|`);
}
